import Login from "@/pages/account/login";
import ForgotPassword from "@/pages/account/forgotPassword";
import RegisterAccount from "@/pages/account/registerAccount";
import User from "@/pages/account/user";
import Info from "@/pages/account/info";
import Certificate from "@/pages/account/certificate";
import Message from "@/pages/Message";
import MessageView from "@/pages/Message/MessageView";
import MessageDetail from "@/pages/Message/MessageDetail";
import PaymentRecord from "@/pages/AccountCenter/PaymentRecord";
import AccountOverview from "@/pages/AccountCenter/AccountOverview";
import RechargeManagement from "@/pages/AccountCenter/RechargeManagement";
import InvoiceManagement from "@/pages/AccountCenter/InvoiceManagement";
import AccountCenter from "@/pages/AccountCenter";
import OrderPay from "@/pages/AccountCenter/OrderPay";
import OnlineRecharge from "@/pages/AccountCenter/OnlineRecharge";
import ApplyInvoice from "@/pages/AccountCenter/InvoiceManagement/ApplyInvoice";

// import Verify from "@/components/verify";

const AccountRoutes = [
  {
    name: "Login",
    path: "login",
    component: <Login />,
  },
  // {
  //   name: "Verify",
  //   path: "verify",
  //   component: <Verify />,
  // },
  {
    name: "ForgotPassword",
    path: "forgot_password",
    component: <ForgotPassword />,
  },
  {
    name: "RegisterAccount",
    path: "register_account",
    component: <RegisterAccount />,
  },
  {
    name: "User",
    path: "user",
    component: <User />,
    children: [
      {
        name: "Info",
        path: "info",
        component: <Info />,
      },
      {
        name: "Certificate",
        path: "certificate",
        component: <Certificate />,
      },
    ],
  },
  {
    name: "Message",
    path: "message",
    component: <Message />,
    children:[
      {
        name: "MessageList",
        path:"list",
        component: <MessageView />
      },{
        name: "MessageDetail",
        path:"detail",
        component: <MessageDetail/>
      }
    ]
  },
  // {
  //   name:"Expense",
  //   path:"expense",
  //   component:<AccountCenter/>,
  //   children:[
  //     {
  //       name: "ExpenseAccount",
  //       path: "overview",
  //       component: <AccountOverview />
  //     },
  //     {
  //       name: "PaymentRecord",
  //       path: "payment",
  //       component: <PaymentRecord />
  //     },{
  //       name: "RechargeManagement",
  //       path: "recharge",
  //       component: <RechargeManagement />
  //     },{
  //       name: "InvoiceManagement",
  //       path: "invoice",
  //       component: <InvoiceManagement />
  //     }
  //   ]
  // },{
  //   name: "OrderPay",
  //   path: "orderPay",
  //   component: <OrderPay/>
  // },{
  //   name: "OnlineRecharge",
  //   path: "onlineRecharge",
  //   component: <OnlineRecharge/>
  // }
];

export default AccountRoutes;
